import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { WelcomeListItemModel } from "../../search/models/welcome-list-item";
import { WelcomeListCollection } from "../../search/collections/welcome-list";
import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AppSettings } from "../../app-settings";
import { AppEvents } from "../../app-events";
import { BaseDocumentModel } from "../../desktop/models/base-document";
import { prop} from "../../decorators/property";
import { ReelItemModel, ReelItemType } from "./reel-item";
import { OverviewReelModel } from "./overview-reel";

export class OverviewResourceReelModel extends OverviewReelModel {

    @prop() public Title = "Welcome";
    @prop() public Type = "resource-reel";

    public Query;
    private requestData: any;
    private resultsData: any;

    constructor() {
        super();
    }

    public loadData() {
        this.Items.reset();
        const aboutItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-about-justisone.html")});
        const trialistItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require<string>("../views/partials/overview-resource-trialist.html")});
        const ipItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require<string>("../views/partials/overview-resource-ipuser.html")});
        const academicItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-academic.html")});
        const jurisdictionItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-select-jurisdiction.html")});
        const searchItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-search.html")});
        const trainingItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-training.html")});
        const signinItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-signin.html")});
        const logoItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-logo.html")});
        const profItem = new ReelItemModel({ ItemType: ReelItemType.Resource, HtmlContent: require("../views/partials/overview-resource-proficiency.html")});

        if (this.user.Sku.toLowerCase() === "free") {
            this.Items.add(logoItem);
            this.Items.add(aboutItem);
            this.Items.add(signinItem);
            // this.Items.add(jurisdictionItem);
            this.Items.add(searchItem);
        }
        else { // standard user / ip user / trialist / academics
            this.Items.add(logoItem);
            this.Items.add(aboutItem);
            // this.Items.add(jurisdictionItem);
            this.Items.add(searchItem);
            this.Items.add(trainingItem);
            this.Items.add(profItem);
        }
        this.trigger("updateDisplay");
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/overview-resource-reel.ts